import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';
import AuthService from '../../services/AuthService';
import AvatarService from '../../services/AvatarService';
import FileUploadService from '../../services/FileUploadService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import AvatarUploadDialog from './AvatarUploadDialog';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class AvatarListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new AvatarService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            renderDialog: false,
            eventDetails: undefined,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
        };
        this.fileUploadService = new FileUploadService();
        this.service = new AvatarService();
        this.handleOpenUploadAvatarDialog = this.handleOpenUploadAvatarDialog.bind(this);
        this.handleCloseUploadAvatarDialog = this.handleCloseUploadAvatarDialog.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    updateSearchCriteria(criteria) {
        return {
            locale: criteria.locale,
            type: criteria.type,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }
    handleOpenUploadAvatarDialog() {
        this.setState({
            renderDialog: true,
        });
    }

    handleCloseUploadAvatarDialog() {
        this.setState({
            renderDialog: false,
        });
    }

    getCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            type: undefined,
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: false,
        };
    }

    initializeFromBackend() {
        this.enumService
            .getLocalizedEnumListForLocale('AvatarType')
            .then((res) => {
                const avatarTypeOptions = res.filter(
                    (avatar) => avatar.enumValue === 'DEFAULT_USER' || avatar.enumValue === 'DEFAULT_GROUP'
                );
                this.setState({
                    avatarTypeOptions,
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getAvatarListError'));
            });

        this.settingService
            .getImageSize()
            .then((imgMaxSizeParameter) => {
                this.setState({
                    imgMaxSizeParameter,
                    fileSizeToTranslation: imgMaxSizeParameter * 0.001 + t('global.maxFileSizeUnit'),
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'avatar.listTitle';
    }
    getCriteriaName() {
        return 'avatar-list-sc';
    }

    getContainerListName() {
        return 'avatar-list-container';
    }
    renderCriteria() {
        return (
            <div>
                <div className='row'>
                    <CriteriaDropdownComponent
                        id='typeSc'
                        name='type'
                        showClear
                        label={t('avatar.type')}
                        value={this.state.criteria.type}
                        options={this.state.avatarTypeOptions}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                        filter
                    />
                </div>
            </div>
        );
    }

    prepareHeaderItems() {
        const {t} = this.props;
        return this.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('avatar.addButton'),
                      onClick: this.handleOpenUploadAvatarDialog,
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    imageBodyTemplate(rowData) {
        return (
            <img
                src={`${new AvatarService().getPath()}/${rowData.fileUuid}?token=${new AuthService().getToken()}`}
                alt='Avatar'
                className='product-image'
                style={{borderRadius: '50%', height: '40px', width: '50px'}}
            />
        );
    }

    prepareColumns() {
        return [
            {field: 'id', header: 'ID', sortable: true, width: '90px'},
            {field: 'type', header: t('avatar.type'), sortable: true},
            {field: 'image', header: t('avatar.image'), body: this.imageBodyTemplate},
            {field: 'action', header: t('global.action'), body: this.actionTemplate},
        ];
    }
    handleGoBack(e) {
        e.preventDefault();
        this.blockUi();
        const {backUrl} = this.props;
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDialog() {
        return (
            <AvatarUploadDialog
                blockUi={this.blockUi}
                unblockUi={this.unblockUi}
                _isMounted={this._isMounted}
                viewMode={'NEW'}
                visible={this.state.renderDialog}
                onHide={this.handleCloseUploadAvatarDialog}
                onClose={this.handleCloseUploadAvatarDialog}
                imgMaxSizeParameter={this.state.imgMaxSizeParameter}
                fileSizeToTranslation={this.state.fileSizeToTranslation}
                afterSave={(e) => {
                    this.handleCloseUploadAvatarDialog(e);
                    this.readMessage();
                    this.refreshTable();
                    this.showSuccessMessage(t('avatar.successfullAdded'));
                    this.unblockUi();
                }}
            />
        );
    }

    handleRemove(e, id) {
        this.service
            .removeAvatar(id)
            .then(() => {
                this.showSuccessMessage(t('avatar.successfullRemove'));
                this.refreshTable();
            })
            .catch(() => {
                this.showErrorMessage(t('error.removeAvatarError'));
            });
    }

    actionTemplate(rowData) {
        return (
            <ActionLink
                className='p-link float-right'
                handleClick={(e) => this.handleRemove(e, rowData.id)}
                variant='red'
                iconName='mdi-trash-can'
                iconSide='left'
                iconSize='xs'
                iconColor='red'
            />
        );
    }
    breadCrumbItems() {
        return [{name: t('avatar.listName'), url: '/avatar-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

AvatarListContainer.defaultProps = {
    detailUrl: '/event-log/details',
    lazy: true,
};

AvatarListContainer.propTypes = {
    detailUrl: PropTypes.string,
};

export default withRouter(withTranslation()(AvatarListContainer));
